import { useState } from "react";
import { useGeo, detectLocation, resolvePincode, geoErrorText } from "@/lib/geo";
import { toast } from "sonner";
import { MapPin, MapPinOff, Loader2, Crosshair } from "lucide-react";

// Care is limited to the configured city (Jodhpur). Prompts for location when unknown, warns when outside.
export function CareAreaBanner() {
    const geo = useGeo();
    const [pin, setPin] = useState("");
    const [busy, setBusy] = useState(false);
    if (geo && geo.care_available === true) return null;
    const outside = geo && geo.care_available === false;
    const run = async (fn) => {
        setBusy(true);
        try {
            const g = await fn();
            g.care_available ? toast.success(`HOMIIE Care is available here`) : toast.error(`HOMIIE Care is available in ${g.care_city || "Jodhpur"} only`);
        } catch (e) { toast.error(geoErrorText(e)); }
        finally { setBusy(false); }
    };
    return (
        <div className="px-5 pt-3" data-testid="care-area-banner">
            <div className={`rounded-2xl border p-4 ${outside ? "border-red-200 bg-red-50" : "border-[#F43F5E]/20 bg-white"}`}>
                <div className="flex items-start gap-3">
                    {outside ? <MapPinOff size={20} className="mt-0.5 shrink-0 text-red-500" /> : <MapPin size={20} className="mt-0.5 shrink-0 text-[#F43F5E]" />}
                    <div className="flex-1">
                        <p className="font-heading text-sm font-bold text-navy">{outside ? `HOMIIE Care is available in ${geo.care_city || "Jodhpur"} only` : "Confirm your location for Care"}</p>
                        <p className="mt-0.5 text-xs text-navy/60">{outside ? "Bookings and plans can't be placed for this location yet. Change location if you're booking for someone in Jodhpur." : "HOMIIE Care currently serves Jodhpur. Share your location or enter a pincode to continue."}</p>
                    </div>
                </div>
                <div className="mt-3 flex flex-wrap items-center gap-2">
                    <button data-testid="care-area-detect-btn" disabled={busy} onClick={() => run(detectLocation)} className="flex items-center gap-1.5 rounded-full bg-[#F43F5E] px-3.5 py-2 text-xs font-bold text-white active:scale-95 disabled:opacity-60">
                        {busy ? <Loader2 size={13} className="animate-spin" /> : <Crosshair size={13} />} Use my location
                    </button>
                    <input data-testid="care-area-pincode" value={pin} onChange={(e) => setPin(e.target.value.replace(/\D/g, "").slice(0, 6))} placeholder="Pincode" className="w-24 rounded-full border border-navy/15 bg-white px-3 py-1.5 text-xs outline-none focus:border-[#F43F5E]" />
                    <button data-testid="care-area-pincode-btn" disabled={busy || pin.length !== 6} onClick={() => run(() => resolvePincode(pin))} className="rounded-full border border-navy/15 bg-white px-3 py-1.5 text-xs font-bold text-navy disabled:opacity-40">Check</button>
                </div>
            </div>
        </div>
    );
}
